export const paymentDetailSelector = state => state?.offer?.detail || {};